module.exports = __webpack_public_path__ + "img/instagram-icon.f31be330.svg";